export const fileUploadStyles = {
  input: {
    class: 'hidden',
  },
  buttonbar: {
    class: [
      // Flexbox
      'flex',
      'flex-wrap',
      'w-full',

      // Colors
      'bg-surface-50',
      'text-surface-700',

      // Spacing
      'p-5',
      'gap-8',

      // Borders
      'border',
      'border-solid',
      'border-surface-200',
      'border-b-0',

      // Shape
      'rounded-tr-lg',
      'rounded-tl-lg',
    ],
  },
  chooseButton: {
    class: [
      'relative',

      // Alignments
      'items-center inline-flex text-center align-bottom justify-center',

      // Spacing
      'px-4 py-1.5',

      // Shape
      'rounded-md',

      // Font
      'text-sm',
      'font-semibold',

      // Colors
      'text-white',
      'bg-primaryGold',
      'border-primary-500',

      // States
      'hover:bg-primary-600',

      // Misc
      'overflow-hidden',
      'cursor-pointer',
    ],
  },
  chooseIcon: {
    class: ['mr-2', 'inline-block'],
  },
  chooseButtonLabel: {
    class: ['flex-1', 'font-bold'],
  },
  uploadbutton: {
    icon: {
      class: 'mr-2',
    },
    class: ['bg-primary-500'],
  },
  cancelbutton: {
    class: ['bg-neutral-400'],
  },
  content: {
    class: [
      // Position
      'relative',

      // Colors
      'bg-surface-0',
      'text-surface-700',

      // Spacing
      'p-8',
      'w-full',
      'min-h-[25rem]',
      'max-h-[50rem]',

      // Borders
      'border',
      'border-surface-200',

      // Shape
      'rounded-b-lg',
    ],
  },
  file: {
    class: [
      // Flexbox
      'flex',
      'items-center',
      'flex-wrap',

      // Spacing
      'p-4',
      'mb-2',
      'last:mb-0',
      'w-full',

      // Borders
      'border',
      'border-surface-200',
      'gap-2',

      // Shape
      'rounded',
    ],
  },
  thumbnail: {
    class: 'shrink-0',
  },
  fileName: {
    class: 'mb-2 break-all',
  },
  fileSize: {
    class: 'mr-2',
  },
  uploadicon: {
    class: 'mr-2',
  },
  progressbar: {
    root: {
      class: [
        // Position and Overflow
        'overflow-hidden',
        'absolute top-0 left-0',

        // Shape and Size
        'border-0',
        'h-2',
        'rounded-md',
        'w-full',

        // Colors
        'bg-surface-100',
      ],
    },
    value: {
      class: [
        // Flexbox & Overflow & Position
        'absolute flex items-center justify-center overflow-hidden',

        // Colors
        'bg-primary-500',

        // Spacing & Sizing
        'm-0',
        'h-full w-0',

        // Shape
        'border-0',

        // Transitions
        'transition-width duration-1000 ease-in-out',
      ],
    },
  },
};
